import type { App } from 'vue'

import {
  // Components
  Dropdown,
  Menu,
  Tooltip,
  vClosePopper,
  // Directives
  vTooltip,
} from 'floating-vue'

import 'floating-vue/dist/style.css'

export default {
  install: (app: App) => {
    app.directive('tooltip', vTooltip)
    app.directive('close-popper', vClosePopper)

    app.component('VDropdown', Dropdown)
    app.component('VTooltip', Tooltip)
    app.component('VMenu', Menu)
  },
}
